import { useState, useEffect, useMemo, useCallback } from 'react';

import { AutoCompleteSelectUI, DataGridUI, DataGridIdentifiers, DebouncedInputUI, FormLabelUI } from '../../Interface';
import { dataGridColumns, generateFilter } from '../../../utils/helper';
import biService from '../../../service/bi.service';

const BiDataSourceReports = ({ refetch, values, viewField, operatorsDisabled, dataset }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const [query, setQuery] = useState({
    filter: [],
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
  });

  const [filterFormState, setFilterFormState] = useState({
    name: '',
    element: '',
  });

  const conditions = useMemo(
    () => ({
      like: ['name'],
    }),
    []
  );

  const getList = useCallback(() => {
    biService.getBiHeads(query).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  }, [query, setRefetchTable]);

  useEffect(() => {
    const defaultFilter = [];

    const newFilter = generateFilter(filterFormState, conditions);
    setQuery((prev) => {
      return { ...prev, filter: [...defaultFilter, ...newFilter] };
    });
  }, [filterFormState, conditions]);

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  useEffect(() => {
    if (Object.keys(query).length > 0) {
      getList();
    }
  }, [query, getList]);

  useEffect(() => {
    if (refetchTable) {
      getList();
    }
  }, [refetchTable, getList]);

  const onPaginitonChange = (paginationModel) => {
    setQuery((prev) => {
      return { ...prev, pagination: { paginationModel } };
    });
  };

  const handleSortModelChange = (sortModel) => {
    setQuery((prev) => {
      const paginationModel = {
        pageSize: prev.pagination.paginationModel.pageSize,
        page: 0,
      };

      return {
        ...prev,
        sorting: { sortModel },
        pagination: { paginationModel },
      };
    });
  };

  const columns = dataGridColumns([
    {
      field: 'name',
      headerName: 'Alias név',
      flex: 1,
    },
    {
      field: 'element',
      headerName: 'Forrás',
      flex: 1,
    },
  ]);

  return (
    <div className="flex  overflow-hidden m-4 ">
      <div className="h-full w-full  overflow-x-auto ">
        <div className="grid grid-cols-4 gap-x-4 mx-4">
          <div className="col-span-2 md:col-span-1">
            <DebouncedInputUI
              label="Alias név"
              debounceMs={500}
              setQuickFilterSearchValue={(newValue) => {
                setFilterFormState((prevState) => ({
                  ...prevState,
                  name: newValue,
                }));
              }}
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <AutoCompleteSelectUI
              label={<FormLabelUI text={'Forrás'} />}
              selectedValue={filterFormState.element}
              dataset={dataset.biViews}
              onChange={(_e, newVal, reason) => {
                if (reason === 'clear') {
                  setFilterFormState((prevState) => ({
                    ...prevState,
                    element: '',
                  }));
                } else {
                  setFilterFormState((prevState) => ({
                    ...prevState,
                    element: newVal.value,
                  }));
                }
              }}
            />
          </div>
        </div>

        <div className="inline-block w-full border-b border-gray-200 align-middle mt-4 overflow-y-auto overflow-x-auto ">
          <DataGridUI
            datagridIdentifier={DataGridIdentifiers.biHead}
            initialState={query}
            rows={reports.rows}
            rowCount={reports.rowCount}
            columns={columns}
            onRowClick={(rowData) => {
              if (!viewField) return;
              setSelectedValues(rowData.row);
            }}
            paginationMode="server"
            onPaginationModelChange={onPaginitonChange}
            sortingMode="server"
            onSortModelChange={handleSortModelChange}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            disableRowSelectionOnClick={!viewField}
          />
        </div>
      </div>
    </div>
  );
};

export default BiDataSourceReports;
